import React from "react";
import { Box } from "@mui/material";
import { StyledTooltipHeading, StyledTooltipText } from "./TooltipTitle.styled";

interface TooltipTitleProps {
  heading?: string;
  text: string;
}

export function TooltipTitle({ heading, text }: TooltipTitleProps) {
  return (
    <Box display="flex" flexDirection="column" gap="2px">
      {heading && <StyledTooltipHeading>{heading}</StyledTooltipHeading>}
      <StyledTooltipText>{text}</StyledTooltipText>
    </Box>
  );
}
